.wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: var(--white);
  padding: 3rem 1.5rem 5rem 1.5rem;
  border-radius: 0 0 8px 8px;
}

.input {
  width: 275px;
}

.input:disabled {
  background-color: #fcfcfc;
  border-color: var(--gray-light);
  color: var(--gray-alt);
}

.notifyContainer {
  display: flex;
}

.notifyIcon {
  width: 55px;
}

.consentContainer {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  margin-bottom: 1.5rem;
  font-family: 'Aeroport';
  color: var(--gray-dark);
  font-size: 15px;
}

.consentContainer input {
  margin-right: 0.5rem;
}

.link {
  font-family: Aeroport;
  font-size: 0.9rem;
  color: var(--text-dark);
}

.link:hover {
  color: var(--text-dark) !important;
}
